/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import { BoardIcon } from '@trello/nachos/icons/board';
import React, { useCallback } from 'react';
import Media from 'react-media';

import { HeaderTestIds } from '@trello/test-ids';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { ScreenBreakpoints } from 'app/src/components/Responsive';
import { forTemplate } from 'app/common/lib/util/i18n';

import HeaderButton from './button';
import styles from './header.less';
import { useFeatureFlag } from '@trello/feature-flag-client';
import { Analytics } from '@trello/atlassian-analytics';
import {
  useBoardsMenuVisibility,
  BoardsMenuVisibilityState,
} from 'app/src/components/BoardsMenuVisibility';

const format = forTemplate('boards_sidebar');

const HeaderBoardMenuButton: React.FunctionComponent = () => {
  const {
    boardsMenuVisibility,
    setBoardsMenuVisibility,
  } = useBoardsMenuVisibility();
  const sendGASEvent = useFeatureFlag('dataeng.gasv3-event-tracking', false);

  const onHeaderButtonClick = useCallback(() => {
    if (sendGASEvent) {
      Analytics.sendClickedButtonEvent({
        buttonName: 'boardsMenuButton',
        source: 'appHeader',
      });
    }

    if (boardsMenuVisibility === BoardsMenuVisibilityState.CLOSED) {
      setBoardsMenuVisibility(BoardsMenuVisibilityState.POPOVER);

      trackUe({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.BOARDS_MENU,
        method: 'by clicking boards button in header',
      });
    }
  }, [sendGASEvent, boardsMenuVisibility, setBoardsMenuVisibility]);

  return (
    <HeaderButton
      icon={<BoardIcon color="light" />}
      onClick={onHeaderButtonClick}
      testId={HeaderTestIds.BoardsMenuButton}
      ariaLabel={forTemplate('header_user')('boards-menu')}
    >
      <Media query={ScreenBreakpoints.MediumMin}>
        {(matches: boolean) => (
          <span
            className={classNames(
              styles.boardsButtonText,
              !matches && styles.boardsButtonTextCollapsed,
            )}
          >
            {format('boards')}
          </span>
        )}
      </Media>
    </HeaderButton>
  );
};

export default HeaderBoardMenuButton;
